export default {
  formId: "qr-code-log-in",
  formField: {
    code: {
      name: "code",
      label: "Six digit employee number",
      type: "text",
      errorMsg: "Six digit employee number are required",
      invalidMsg: "Code is invalid",
    },
    auth: {
      name: "auth",
      label: "Last 4 digits of ssn",
      type: "text",
      errorMsg: "Last 4 digits of ssn are required",
      invalidMsg: "Last 4 digits of ssn are not valid",
    },
  },
};
